import { render, staticRenderFns } from "./use-record.vue?vue&type=template&id=84433ffe&scoped=true&"
import script from "./use-record.vue?vue&type=script&lang=js&"
export * from "./use-record.vue?vue&type=script&lang=js&"
import style0 from "./use-record.vue?vue&type=style&index=0&id=84433ffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84433ffe",
  null
  
)

export default component.exports